import { streamCardV2Main } from '@synoptic/ui-kit/stream-card-v2/stream-card-v2.css.js';
import {
  StreamCardV2,
  StreamCardV2Body,
  StreamCardV2Footer,
  StreamCardV2Header,
  StreamCardV2Targets,
} from '@synoptic/ui-kit/stream-card-v2/stream-card-v2.js';
import { clsx } from 'clsx';
import { StreamCardFragmentFragment } from '@/__generated__/graphql.ts';
import { getUserAvatarSrc } from '@/components/s3/user/get-user-avatar-src.ts';
import { getStreamCategoryTitle } from '@/components/streams/stream-categories.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { formatNumber } from '@/utils/format-number.ts';
import { streamCardLinkV2 } from './stream-card-link-v2.css.ts';
import { streamCardPriceV2 } from './stream-card-price-v2.ts';
import { streamCardTargetsV2 } from './stream-card-targets-v2.ts';

export type StreamCardLinkV2Stream = StreamCardFragmentFragment & {
  following?: boolean | null;
  customTargets?: readonly string[] | null;
};

export const StreamCardLinkV2 = ({
  stream,
}: {
  stream: StreamCardLinkV2Stream;
}) => {
  const streamHref = paths.makeStream(stream.id);
  const authorHref = paths.makeUser(stream.author.username);
  const targets = streamCardTargetsV2(stream);

  return (
    <StreamCardV2>
      <Link
        className={clsx(streamCardLinkV2, streamCardV2Main)}
        to={streamHref}
        data-testid="stream-card-link-v2"
      >
        <StreamCardV2Header
          kind={stream.customTargetsData ? 'custom' : 'data'}
          category={getStreamCategoryTitle(stream.streamCategory)}
          price={streamCardPriceV2(stream)}
        />
        <StreamCardV2Body
          title={stream.name}
          description={stream.description}
        />
        {targets ? <StreamCardV2Targets {...targets} /> : null}
      </Link>
      <StreamCardV2Footer
        handle={stream.author.username}
        avatarSrc={getUserAvatarSrc(
          stream.author.id,
          stream.author.avatar?.key,
          'v2s',
        )}
        followers={formatNumber(stream.followersCount)}
        renderHandle={
          <Link to={authorHref} data-testid="stream-card-author-v2" />
        }
      />
    </StreamCardV2>
  );
};
